export default function setupDropdownHandlers() {
  const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
  const dropdownMenus = document.querySelectorAll(".dropdown-menu");

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const dropdown = toggle.closest(".dropdown");
      const hiddenMenu = dropdown?.querySelector(".dropdown-menu.d-none");

      if (hiddenMenu) {
        hiddenMenu.classList.remove("d-none");
      }
    });
  });

  dropdownMenus.forEach((menu) => {
    menu.addEventListener("click", function (event) {
      event.stopPropagation();

      const hasNestedMenu = menu.querySelector(".dropdown-menu");

      if (hasNestedMenu) return;

      let currentElement = menu;
      let outermostDropdown = menu;

      while (currentElement.closest(".dropdown")) {
        outermostDropdown = currentElement.closest(".dropdown");
        currentElement = outermostDropdown.parentElement;
      }

      const outerMenu = outermostDropdown.querySelector(".dropdown-menu");

      if (outerMenu) {
        outerMenu.classList.add("d-none");
        outerMenu.classList.remove("show");
      }
    });
  });
}
